var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaxWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 64,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    transform: "translate(-218 -3648)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1196,
    transform: "translate(-223 -552)",
    fill: "#312F30"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -163,
    width: 577,
    height: 123,
    rx: 15,
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: -24,
    width: 577,
    height: 123,
    rx: 15,
    fill: "white",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8332 51.7085H14.1665C13.4148 51.7085 12.7915 51.0852 12.7915 50.3335C12.7915 49.5818 13.4148 48.9585 14.1665 48.9585H50.8332C51.5848 48.9585 52.2082 49.5818 52.2082 50.3335C52.2082 51.0852 51.5848 51.7085 50.8332 51.7085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0833 21.4215C35.36 21.4215 33.6367 21.0915 31.9867 20.4315C31.4733 20.2298 31.125 19.7165 31.125 19.1481V13.6481C31.125 13.1898 31.345 12.7682 31.73 12.5115C32.115 12.2548 32.5917 12.1998 33.0133 12.3648C35.635 13.4098 38.5317 13.4098 41.1533 12.3648C41.575 12.1998 42.0517 12.2548 42.4367 12.5115C42.8217 12.7682 43.0417 13.1898 43.0417 13.6481V19.1481C43.0417 19.7165 42.6933 20.2115 42.18 20.4315C40.53 21.0915 38.8067 21.4215 37.0833 21.4215ZM33.875 18.1948C35.965 18.8364 38.2017 18.8364 40.2917 18.1948V15.5365C38.1833 16.0499 35.9833 16.0499 33.875 15.5365V18.1948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 26.0415C31.7483 26.0415 31.125 25.4182 31.125 24.6665V19.1665C31.125 18.4148 31.7483 17.7915 32.5 17.7915C33.2517 17.7915 33.875 18.4148 33.875 19.1665V24.6665C33.875 25.4182 33.2517 26.0415 32.5 26.0415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1668 51.7082H17.8335C17.0818 51.7082 16.4585 51.0848 16.4585 50.3332V30.1665C16.4585 25.7298 18.8968 23.2915 23.3335 23.2915H41.6668C46.1035 23.2915 48.5418 25.7298 48.5418 30.1665V50.3332C48.5418 51.0848 47.9185 51.7082 47.1668 51.7082ZM19.2085 48.9582H45.7918V30.1665C45.7918 27.2698 44.5635 26.0415 41.6668 26.0415H23.3335C20.4368 26.0415 19.2085 27.2698 19.2085 30.1665V48.9582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1036 33.375H18.897C18.1453 33.375 17.522 32.7517 17.522 32C17.522 31.2483 18.1453 30.625 18.897 30.625H46.1036C46.8553 30.625 47.4786 31.2483 47.4786 32C47.4786 32.7517 46.8553 33.375 46.1036 33.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5239 32H23.7739V50.3333H26.5239V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8569 32H31.1069V50.3333H33.8569V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1904 32H38.4404V50.3333H41.1904V32Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -47.5,
    y: -163,
    width: 625,
    height: 171,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_0_1",
    x: -47.5,
    y: -28,
    width: 625,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7068,
    fill: "white",
    transform: "translate(-218 -3648)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxWhite);
export default __webpack_public_path__ + "static/media/tax-white.9d49af8079a79bec4807d48f8d5badb7.svg";
export { ForwardRef as ReactComponent };